$(document).ready(function () {
    // + menu open & close
    $(".menu-control, .left-menu-shadow").click(function () {
        $(".main-wrapper, header .header--tab").toggleClass("active");
        $(".menu-control i").hasClass("icon-right-open")
            ? $(".menu-control i")
                .removeClass("icon-right-open")
                .addClass("icon-left-open")
            : $(".menu-control i")
                .removeClass("icon-lef-opent")
                .addClass("icon-right-open");
        $(".left-menu").find(".sub-menu").slideUp();
        if ($(".main-wrapper, header .header--tab").hasClass("active")) {
            $(".left-menu-shadow").addClass("active");
            $("body").addClass("scroll-disabled");
        } else {
            $(".left-menu-shadow").removeClass("active");
            $(".left-menu .sub-menu-control i")
                .removeClass("icon-up")
                .addClass("icon-down");
            $("body").removeClass("scroll-disabled");
        }
    });
    // - menu open & close

    // + nav
    $(".left-menu .menu-item").click(function () {
        var subMenu = $(this).closest("li").find("> .sub-menu");

        $(this)
            .closest("ul")
            .find("> li")
            .not($(this).closest("li"))
            .find(".sub-menu:visible")
            .slideUp();

        $(this)
            .closest("ul")
            .find(".sub-menu-control i")
            .removeClass("icon-up")
            .addClass("icon-down");

        if (subMenu.css("display") !== "block") {
            $(this)
                .find(".sub-menu-control i")
                .addClass("icon-up")
                .removeClass("icon-down");
            $(this).closest("li").siblings().find("> .sub-menu:visible").slideUp();
            subMenu.slideDown();
        } else {
            subMenu.find(".sub-menu:visible").slideUp();
            subMenu.slideUp();

            subMenu
                .find(".sub-menu-control i")
                .removeClass("icon-up")
                .addClass("icon-down");
        }
    });
    // - nav

    // + tab control
    $(".main-content iframe").attr("tab-id", 0).addClass("active-tab");
    $(".header--tab__list").on("click", "li:not(:last-child) a", function () {
        $(".header--tab__list a").removeClass("active");
        $(this).addClass("active");
        const link = $(this).attr("link");
        // $(".main-content iframe").attr("src", link);

        const index = $(this).closest("li").index();

        if ($(`.main-content iframe[tab-id='${index}']`).length === 0) {
            const iframe = `<iframe src="${link}" tab-id="${index}" ></iframe>`;
            $(".main-content iframe").last().after(iframe);
        }
        if ($(this).attr("sub-link") === "false") {
            $(".left-menu").hide();
            $(".main-wrapper .main-content").addClass("ps-0");
        } else {
            $(".left-menu").show();
            $(".main-wrapper .main-content").removeClass("ps-0");
        }

        $(".main-content iframe").hide().removeClass("active-tab");
        $(`.main-content iframe[tab-id='${index}']`).show().addClass("active-tab");
    });

    $(".header--tab__list").on("click", "a .close", function () {
        $(this).closest("li").remove();
        setTimeout(function () {
            $(".header--tab__list li:first-child a").click().addClass("active");
        }, 300);
    });

    $(".new-dashboard-links li a").on("click", function () {
        var listItemCount = $(".header--tab__list li").length;

        if (listItemCount >= 7) {
            alert("Sekme sayısı 6'dan fazla olamaz.");
            return;
        }

        var myModalEl = document.getElementById("modalTabSelect");
        var modalInstance = bootstrap.Modal.getInstance(myModalEl);
        if (modalInstance) {
            modalInstance.hide();
        }

        var link = $(this).attr("link");
        var subLinkValue = link.includes("http") ? "false" : "true";
        var text = $(this).text();

        var newTab = $(
            '<li><a sub-link="' +
            subLinkValue +
            '" link="' +
            link +
            '">' +
            text +
            ' <i class="icon-cancel close"></i></a></li>'
        );

        $(".add-tab").before(newTab);
        $(".header--tab__list li").eq(-2).find("a").click();
    });
    // - tab control

    // + header height
    const headerHeight = $("header").height();
    var leftMenuTop = $("header .header-top").height();

    function setHeaderHeight() {
        $(".left-menu").css("top", leftMenuTop);
        $(".main-content").css("padding-top", headerHeight + 10);
        $(".phone-wrapper").css("padding-top", headerHeight + 10);
    }
    setHeaderHeight();

    $(window).resize(function () {
        setHeaderHeight();
    });
    // - header height

    // + datatable
    if ($(".bootstrap-datatable").length > 0) {
        $(".bootstrap-datatable").DataTable({
            scrollX: true,
            language: {
                url: "/assets/js/datatable/tr.json",
            },
        });
    }
    $(".dt-container .dt-scroll-body").on("scroll", function () {
        $(".dropdown-menu.show").removeClass("show").hide();
    });
    // - datatable

    // + select 2
    if ($(".custom-select").length > 0) {
        $(".custom-select select").select2({
            dropdownAutoWidth: true,
        });
    }
    if ($(".custom-tag").length > 0) {
        $(".custom-tag select").select2({
            tags: true,
            tokenSeparators: [",", " "],
        });
    }
    // - select 2

    // + dual list
    if ($(".dual-list").length > 0) {
        var dlb1 = new DualListbox(".dual-list");
    }
    // - dual list

    // + file upload
    if ($(".filepond").length > 0) {
        const maxWitdh = $(".filepond").attr("maxWitdh");
        const maxHeight = $(".filepond").attr("maxHeight");

        FilePond.registerPlugin(
            FilePondPluginImageExifOrientation,
            FilePondPluginImagePreview,
            FilePondPluginImageValidateSize
        );

        FilePond.create(document.querySelector(".filepond"), {
            labelIdle: `Drag & Drop your picture or <span class="filepond--label-action">Browse</span>`,
            imagePreviewHeight: 256,
            imageCropAspectRatio: "1:1",
            imageResizeTargetWidth: 250,
            imageResizeTargetHeight: 250,
            imageValidateSizeMaxWidth: maxWitdh, // Yüklenen görselin witdh
            imageValidateSizeMaxHeight: maxHeight, // Yüklenen görselin height
        });
        const pond = document.querySelector(".filepond");
        pond.addEventListener("FilePond:addfile", (e) => {
            console.log("File added", e.detail);
        });
    }
    // - file upload

    // + datepicker
    if ($(".t-datepicker").length > 0) {
        $(".t-datepicker").each(function () {
            var $datepicker = $(this);

            var valCheckIn = $datepicker.find(".checkInInput").val();
            var valCheckOut =
                $datepicker.find(".checkOutInput").length > 0
                    ? $datepicker.find(".checkOutInput").val()
                    : null;

            $datepicker
                .tDatePicker({
                    dateCheckIn: valCheckIn,
                    dateCheckOut: valCheckOut,
                })
                .on("onChangeCI", function (e, changeDateCI) {
                    $datepicker.find(".checkInInput").val(formatDate(changeDateCI));
                })
                .on("onChangeCO", function (e, changeDateCO) {
                    $datepicker.find(".checkOutInput").val(formatDate(changeDateCO));
                });
        });
        function formatDate(timestamp) {
            var date = new Date(timestamp);
            var day = date.getDate().toString().padStart(2, "0");
            var month = (date.getMonth() + 1).toString().padStart(2, "0");
            var year = date.getFullYear();
            return `${year}-${month}-${day}`;
        }
    }
    // - datepicker

    // + popper
    if ($("[data-bs-toggle='popover']").length > 0) {
        const popoverTriggerList = document.querySelectorAll(
            '[data-bs-toggle="popover"]'
        );
        const popoverList = [...popoverTriggerList].map(
            (popoverTriggerEl) => new bootstrap.Popover(popoverTriggerEl)
        );
    }
    // - popper

    // + incoming call
    $(".toast-container.incoming-call #call-accept").on("click", function () {
        $(".incoming-call .toast").removeClass("show").addClass("hide");
        $("#btn-call-on, #status-call-mute, #status-call-off").addClass("d-none");
        $("#btn-call-mute, #btn-call-off, #status-call-on").removeClass("d-none");
        setTimeout(() => {
            $(".modal-dialog .bootstrap-datatable").DataTable().destroy();
            $(".modal-dialog .bootstrap-datatable").DataTable({
                scrollX: true,
            });
        }, 400);
    });
    // - incoming call

    // + editor
    if ($(".custom-editor").length > 0) {
        $(".custom-editor").summernote({
            height: 300,
        });
    }
    // - editor

    $(".header-status li a").click(function () {
        $(".header-status button .header-status-content").html(this.innerHTML);
    });



    // + editor
    $("#show-toast").on("click", function () {
        new Notify({
            status: "success",
            title: "Notify Title",
            text: "Notify text lorem ipsum",
            autoclose: true,
        });
    });
    // - editor
});
